export default "__VITE_ASSET__8UVH5Sfx__"